import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaHeadset, FaFileImport, FaEraser, FaTrash } from "react-icons/fa";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import api from "../../services/api";
import { formataDataExibicao, hasPerm, formataCPF, getCurrentUser} from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import ExportPDF from "./ExportPDF";
import ExportCSVExcel from "./ExportCSVExcel";

class Pacientes extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaPaciente = this.buscaPaciente.bind(this);

        this.state = {
            listPacientes: [],
            error: "",
            busca: "",
            busca_id: "",
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            programa_select_key: 0,
            listSelecionados: [],
            filtro_cadastro_teste: false,
            page_numb: 1,
            loading: true,
            showModal: false,
        };

        // Bind de métodos
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
    }

    componentDidMount(){
        this.consultaPacientes(this.state.busca, this.state.page_numb, this.state.filtro_cliente_id, this.state.filtro_programa_id)
    }

    handleShowModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    // Método chamado quando um arquivo é selecionado
    handleFileChange(event) {
        const file = event.target.files[0];
        // Aqui você pode implementar o processamento do arquivo
        this.handleCloseModal(); // Opcional: feche o Modal após selecionar o arquivo
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 ,
                listSelecionados: []
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                listSelecionados: []
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    consultaPacientes(busca, page_numb=1){
        let dados_usuario = getCurrentUser();
        
        let url=`/pessoas/beneficiarios/?nome=${busca}&page=${page_numb}&tipo_usuario=${dados_usuario['tipo_usuario']}`

        if(dados_usuario['ambiente_cliente_id']){
            url += `&cliente_id=${dados_usuario['ambiente_cliente_id']}&programa_id=${dados_usuario['ambiente_programa_id']}`;
        }

        if(this.state.filtro_cliente_id){
            url += `&cliente_id=${this.state.filtro_cliente_id}`
        }
        if (this.state.filtro_programa_id) {
            url += `&programa_id=${this.state.filtro_programa_id}`;
        }
        
        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listPacientes: response.data,
                listSelecionados: [],
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar pacientes, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    /*async consultaPacientes(busca, busca_id, filtro_cliente_id, filtro_programa_id, page_numb=1){
        let dados_usuario = getCurrentUser();
        const cliente_id = filtro_cliente_id || dados_usuario['ambiente_cliente_id'];
        const programa_id =  dados_usuario['ambiente_programa_id'] || '';
    
        let url = `/pessoas/beneficiarios/?nome=${busca}&page=${page_numb}&tipo_usuario=${dados_usuario['tipo_usuario']}` + 
            (cliente_id ? `&cliente_id=${cliente_id}` : '') + (programa_id ? `&programa_id=${programa_id}` : '');

        if(this.state.filtro_cadastro_teste){
            url += '&cadastro_teste=1';
        }
        
        try {
            const response = await api.get(url);
            const pacientes = response.data.results;
            
            this.setState({ listPacientes: { ...response.data }, loading: false, error: "", });
        } catch (error) {
            let erro_msg = 'Erro ao consultar pacientes, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        }
    }*/
 
    renderRows = () => {
        const { listPacientes } = this.state;
        const dados_usuario = getCurrentUser();

        // Verifica se existem resultados e se eles têm pelo menos um item
        if (listPacientes.results && listPacientes.results.length > 0) {
            return listPacientes.results.map((item) => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.cpf ? formataCPF(item.cpf) : ''}</td>
                    <td>{item.telefone}</td>
                    <td>{item.dados_cliente.nome ? item.dados_cliente.nome : '-'} / {item.dados_programa.nome ? item.dados_programa.nome : '-'}</td>
                    <td>
                        {hasPerm('add_beneficiarios') && (
                            <>
                                <Button variant="light" href={"/pacientes/edit/"+item.id+"/?cliente_id="+item.cliente_id+""} size="sm">
                                    <FaRegEdit /> Editar
                                </Button>
                                {' '} {/* Adiciona espaço entre os botões */}
                                <Button variant="light" href={`/atendimentos/?paciente=${item.id}`} size="sm">
                                    <FaHeadset /> Ver Atendimentos
                                </Button>
                            </>
                        )}
                        {dados_usuario?.is_superuser && (
                            <>
                                {' '}
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="text-danger p-1"
                                    title="Excluir paciente"
                                    aria-label="Excluir paciente"
                                    onClick={() => this.excluirPaciente(item)}
                                >
                                    <FaTrash />
                                </Button>
                            </>
                        )}
                    </td>
                </tr>
            ));
        }

        // Se não houver resultados, renderiza uma linha indicando que nenhum paciente foi cadastrado
        return (
            <tr>
                <td colSpan={6}>Nenhum paciente cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.consultaPacientes(this.state.busca, num_page);
        });
    }

    buscaPaciente(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaPacientes(this.state.busca, 1)
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_cliente_id: null,
            filtro_programa_id: null,
            filtro_cadastro_teste: null,
        }, () => {
            this.consultaPacientes(this.state.busca, 1);
        })
    }

    excluirPaciente = async (item) => {
        const MySwal = withReactContent(Swal);
        const pacienteId = item.id;
        const pacienteNome = item.nome;

        Swal.fire({
            title: 'Verificando atendimentos...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        let atendimentos = [];
        try {
            const resp = await api.get(`/atendimentos/?beneficiario_id=${pacienteId}`);
            atendimentos = resp.data.results || [];
        } catch (error) {
            console.error('Erro ao buscar atendimentos do paciente', error);
            MySwal.fire('Erro!', 'Não foi possível verificar os atendimentos do paciente. Tente novamente.', 'error');
            return;
        }

        Swal.close();

        const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        const temAtendimentos = atendimentos.length > 0;
        const idsAtendimentos = atendimentos.map(a => `#${a.id}`).join(', ');

        const html = `
            <div style="text-align: left;">
                <p>Tem certeza que deseja excluir o paciente <strong>${escapeHtml(pacienteNome)}</strong> (ID <strong>${pacienteId}</strong>)?</p>
                <div class="alert alert-danger mb-2" role="alert">
                    <strong>Atenção:</strong> Esta ação <strong>não pode ser revertida</strong> e excluirá em cascata <strong>todos os dados relacionados ao paciente</strong>, incluindo atendimentos, agendamentos e demais registros vinculados.
                </div>
                ${temAtendimentos ? `
                    <p class="mb-1">${atendimentos.length === 1 ? 'Atendimento que será excluído' : 'Atendimentos que serão excluídos'}: <strong>${escapeHtml(idsAtendimentos)}</strong>.</p>
                ` : ''}
                <hr/>
                <div class="mb-2">
                    <label for="swal-confirma-id" class="form-label">Para confirmar, digite o ID do paciente (<strong>${pacienteId}</strong>):</label>
                    <input id="swal-confirma-id" class="form-control" type="text" inputmode="numeric" autocomplete="off" placeholder="ID do paciente" />
                </div>
            </div>
        `;

        const result = await MySwal.fire({
            title: 'Excluir paciente?',
            html: html,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,
            preConfirm: () => {
                const input = document.getElementById('swal-confirma-id');
                const valorDigitado = input ? input.value.trim() : '';
                if (valorDigitado !== String(pacienteId)) {
                    Swal.showValidationMessage(`Digite o ID ${pacienteId} para confirmar.`);
                    return false;
                }
                return true;
            }
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: 'Excluindo paciente...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            await api.delete(`/pessoas/beneficiarios/${pacienteId}/`);

            MySwal.fire('Excluído!', 'O paciente e os registros relacionados foram excluídos com sucesso.', 'success');
            this.setState({ loading: true }, () => {
                this.consultaPacientes(this.state.busca, this.state.page_numb);
            });
        } catch (error) {
            console.error('Erro ao excluir paciente', error);
            MySwal.fire('Erro!', 'Houve um erro ao tentar excluir o paciente. Por favor, tente novamente.', 'error');
        }
    };

    getClientePaciente = async (cliente_id) => {
        try {
            const response = await api.get(`/pessoas/clientes/${cliente_id}/`);
            const dados = response.data;
            const cliente_paciente = (dados.dados_pessoa.razao_social) ? `${dados.dados_pessoa.nome_fantasia} (${dados.dados_pessoa.razao_social})` : dados.dados_pessoa.nome_fantasia;
            return cliente_paciente;
        } catch (error) {
            let erro_msg = 'Erro ao consultar cliente do paciente, tente novamente';
            console.error(erro_msg);
            // Aqui poderia retornar um valor padrão ou erro para o cliente
            return '-';
        }
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarProgramas = async (inputValue) => {
        if(!this.state.filtro_cliente_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.filtro_cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    render() {
        const customStyles = {
            option: (provided, state) => ({
              ...provided,
              fontSize: '13px',
            }),
            singleValue: (provided, state) => ({
              ...provided,
              fontSize: '13px',
            }),
          };

        if (!hasPerm('view_beneficiarios')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={2} lg={2}>
                        <h4 className="page-title">Pacientes</h4>
                    </Col>
                    <Col sm={9} lg={9} className="text-start">
                        {hasPerm('add_beneficiarios') && dados_usuario['tipo_usuario'] == '' && (
                        <Button variant="secondary" href="/pacientes/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Paciente
                        </Button>
                        )}
                        {/*hasPerm('add_atendimentos') && (
                        <Button variant="secondary" href="/atendimentos/add" className="mb-3 ms-3" size="sm">
                            <FaPlus /> Adicionar Atendimento
                        </Button>
                        )*/}
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <ExportCSVExcel
                                    filtros={{
                                        busca: this.state.busca,
                                        cliente_id: this.state.filtro_cliente_id,
                                        programa_id: this.state.filtro_programa_id,
                                        cadastro_teste: this.state.filtro_cadastro_teste,
                                    }}
                                />
                                <ExportPDF
                                    filtros={{
                                        busca: this.state.busca,
                                        cliente_id: this.state.filtro_cliente_id,
                                        programa_id: this.state.filtro_programa_id,
                                        cadastro_teste: this.state.filtro_cadastro_teste,
                                    }}
                                />
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaPaciente}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do paciente"
                                                                aria-label="Nome do paciente"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'gestor') && (
                                                    <Col sm={12} xs={12}> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cliente</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarClientes}
                                                                defaultOptions
                                                                name="cliente_id"
                                                                placeholder="Buscar cliente..."
                                                                noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                                onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                                                value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                                                styles={customStyles}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                    {this.state.filtro_cliente_id && (
                                                    <Col sm={12} xs={12}> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Programa</Form.Label>
                                                            <AsyncSelect
                                                                key={this.state.programa_select_key}                                  
                                                                cacheOptions
                                                                loadOptions={this.carregarProgramas}
                                                                defaultOptions
                                                                name="programa_id"
                                                                placeholder="Buscar programa..."
                                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                                value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                                                styles={customStyles}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                type="checkbox"
                                                                id="filtroCadastroTestePacientes"
                                                                label="Apenas pacientes de teste"
                                                                checked={this.state.filtro_cadastro_teste}
                                                                onChange={e => this.setState({ filtro_cadastro_teste: e.target.checked })}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                                
                                                <Button className="ms-0" type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/*<Button variant="light" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>*/}
                                {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'gestor') && (
                                    <Button variant="light" className="ms-2" size="sm" onClick={this.handleShowModal}>
                                        <FaFileImport /> Importar Pacientes
                                    </Button>
                                )}
                            </Col>
                        </Row>  

                        {/* Modal para importação de arquivo */}
                        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Importar Pacientes</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Group>
                                    <Form.Label>Selecione um arquivo Excel para importar:</Form.Label>
                                    <Form.Control 
                                        type="file" 
                                        required={true}
                                        onChange={this.handleFileChange}
                                    />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="" onClick={this.handleCloseModal}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" >
                                    Importar
                                </Button>
                            </Modal.Footer>
                        </Modal>  

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Nome</th>
                                    <th>CPF</th>
                                    <th>Telefone</th>
                                    <th>Cliente/Programa</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={6}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listPacientes && this.state.listPacientes.results.length > 0 && 
                            <Paginacao dados={this.state.listPacientes} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Pacientes);
